<template>
    <div class="rounded border bg-white">
        <div class="flex justify-between p-4 handle">
            <div class="flex items-center space-x-3 truncate">
                <button type="button" class="cursor-move focus:outline-none">
                    <svg class="w-5 h-5 text-gray-500 hover:text-gray-900" fill="none" stroke="currentColor"
                         viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
                    </svg>
                </button>

                <div
                    class="flex items-center space-x-3 -my-4 h-12 cursor-pointer"
                    @click.native="!['dashboardRecentActivity'].includes(data.type) ? data.edit=!data.edit : ''"
                >
                    <svg v-if="data.type === 'dashboardContentBlock'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><polyline fill="none" points="14 2 14 8 20 8" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="16" x2="8" y1="13" y2="13"/><line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="16" x2="8" y1="17" y2="17"/><polyline fill="none" points="10 9 9 9 8 9" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                    <svg v-else-if="data.type === 'dashboardTextBlock'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M5.2498 3C4.00727 3 3 4.00727 3 5.2498V18.7486C3 19.9911 4.00727 20.9984 5.2498 20.9984H11.1644L11.5202 19.5754C11.5266 19.5497 11.5333 19.5241 11.5402 19.4985H5.2498C4.83563 19.4985 4.49987 19.1628 4.49987 18.7486V5.2498C4.49987 4.83563 4.83563 4.49987 5.2498 4.49987H18.7486C19.1628 4.49987 19.4985 4.83563 19.4985 5.2498V11.2317C19.9774 11.0412 20.492 10.9678 20.9984 11.0115V5.2498C20.9984 4.00727 19.9911 3 18.7486 3H5.2498ZM15.3539 14.9989H11.2493C10.835 14.9989 10.4993 15.3347 10.4993 15.7489C10.4993 16.163 10.835 16.4988 11.2493 16.4988H13.8541L15.3539 14.9989ZM8.74949 8.24954C8.74949 8.80177 8.30181 9.24945 7.74958 9.24945C7.19735 9.24945 6.74967 8.80177 6.74967 8.24954C6.74967 7.69731 7.19735 7.24963 7.74958 7.24963C8.30181 7.24963 8.74949 7.69731 8.74949 8.24954ZM11.2493 7.4996C10.8351 7.4996 10.4993 7.83536 10.4993 8.24954C10.4993 8.66371 10.8351 8.99947 11.2493 8.99947H16.7488C17.163 8.99947 17.4987 8.66371 17.4987 8.24954C17.4987 7.83536 17.163 7.4996 16.7488 7.4996H11.2493ZM11.2493 11.2493C10.835 11.2493 10.4993 11.585 10.4993 11.9992C10.4993 12.4134 10.835 12.7491 11.2493 12.7491H16.7486C17.1629 12.7491 17.4985 12.4134 17.4985 11.9992C17.4985 11.585 17.1629 11.2493 16.7486 11.2493H11.2493ZM7.74958 12.9991C8.30181 12.9991 8.74949 12.5515 8.74949 11.9992C8.74949 11.447 8.30181 10.9993 7.74958 10.9993C7.19735 10.9993 6.74967 11.447 6.74967 11.9992C6.74967 12.5515 7.19735 12.9991 7.74958 12.9991ZM8.74949 15.7489C8.74949 16.3011 8.30181 16.7488 7.74958 16.7488C7.19735 16.7488 6.74967 16.3011 6.74967 15.7489C6.74967 15.1966 7.19735 14.749 7.74958 14.749C8.30181 14.749 8.74949 15.1966 8.74949 15.7489ZM19.0984 12.6686L13.1965 18.5705C12.8524 18.9146 12.6083 19.3458 12.4903 19.8179L12.0327 21.6484C11.8336 22.4445 12.5547 23.1656 13.3508 22.9666L15.1813 22.5089C15.6534 22.3909 16.0846 22.1468 16.4287 21.8027L22.3306 15.9008C23.2231 15.0082 23.2231 13.5611 22.3306 12.6686C21.4381 11.7761 19.991 11.7761 19.0984 12.6686Z" fill="#212121"/></svg>
                    <svg v-else-if="data.type === 'dashboardLinks'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z"/></svg>
                    <svg v-else-if="data.type === 'dashboardRecentActivity'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M19 7h5v2h-5V7zm-2 5h7v2h-7v-2zm3 5h4v2h-4v-2zM2 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H2zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/></svg>
                    <svg v-else class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"></path><path d="M13 6v15h-2V6H5V4h14v2z"></path></svg>

                    <span class="text-sm text-gray-900 truncate max-w-96">
                        {{ data.title }}
                        <span v-if="!data.title" class="text-gray-500">
                            <template v-if="data.type === 'dashboardContentBlock'">Content block</template>
                            <template v-if="data.type === 'dashboardTextBlock'">Text block</template>
                            <template v-if="data.type === 'dashboardLinks'">Links</template>
                            <template v-if="data.type === 'dashboardRecentActivity'">Recent activity</template>
                        </span>
                    </span>

                </div>
            </div>
            <!-- Delete/edit buttons -->
            <div class="flex pl-6 space-x-4">
                <button type="button" class="focus:outline-none" @click.native="$emit('remove', data)"
                        v-if="!data.protected">
                    <svg class="w-5 h-5 text-gray-500 hover:text-red-600" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                        <path fill="none" d="M0 0h24v24H0z"/>
                        <path
                            d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z"/>
                    </svg>
                </button>
                <button
                    v-if="!['dashboardRecentActivity'].includes(data.type)"
                    type="button"
                    class="focus:outline-none"
                    @click.native="data.edit=!data.edit"
                >
                    <svg class="w-5 h-5 text-gray-500 hover:text-gray-900"
                         v-bind:class="{ 'text-teal-600 hover:text-teal-700': data.edit }"
                         fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 24 24"
                         width="24"
                         height="24"
                    >
                        <path fill="none" d="M0 0h24v24H0z"/>
                        <path
                            d="M3.34 17a10.018 10.018 0 0 1-.978-2.326 3 3 0 0 0 .002-5.347A9.99 9.99 0 0 1 4.865 4.99a3 3 0 0 0 4.631-2.674 9.99 9.99 0 0 1 5.007.002 3 3 0 0 0 4.632 2.672c.579.59 1.093 1.261 1.525 2.01.433.749.757 1.53.978 2.326a3 3 0 0 0-.002 5.347 9.99 9.99 0 0 1-2.501 4.337 3 3 0 0 0-4.631 2.674 9.99 9.99 0 0 1-5.007-.002 3 3 0 0 0-4.632-2.672A10.018 10.018 0 0 1 3.34 17zm5.66.196a4.993 4.993 0 0 1 2.25 2.77c.499.047 1 .048 1.499.001A4.993 4.993 0 0 1 15 17.197a4.993 4.993 0 0 1 3.525-.565c.29-.408.54-.843.748-1.298A4.993 4.993 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334a8.126 8.126 0 0 0-.75-1.298A4.993 4.993 0 0 1 15 6.804a4.993 4.993 0 0 1-2.25-2.77c-.499-.047-1-.048-1.499-.001A4.993 4.993 0 0 1 9 6.803a4.993 4.993 0 0 1-3.525.565 7.99 7.99 0 0 0-.748 1.298A4.993 4.993 0 0 1 6 12c0 1.26-.47 2.437-1.273 3.334a8.126 8.126 0 0 0 .75 1.298A4.993 4.993 0 0 1 9 17.196zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                    </svg>
                </button>
            </div>
            <!-- ./ Delete/edit buttons -->
        </div>

        <div v-if="data.edit && !['dashboardRecentActivity'].includes(data.type)" class="p-4 bg-gray-50 bg-opacity-75 border-t space-y-4">
            <div class="space-y-4">

                <text-field
                    label="Title"
                    name="option1"
                    v-model="data.title"
                >
                </text-field>

                <text-editor
                    label="Description"
                    :text="data.description"
                    @input="(newValue) => { data.description = newValue }"
                    >
                </text-editor>

                <div>
                    <label class="flex justify-between items-center mb-1.5 text-sm"> Content </label>

                    <div v-if="data.type === 'dashboardContentBlock'">
                        <ContentBlock :data="data" :options="options" :unique_id="unique_id"></ContentBlock>
                    </div>

                    <div v-if="data.type === 'dashboardTextBlock'">
                        <TextBlock :data="data" :options="options" :unique_id="unique_id"></TextBlock>
                    </div>

                    <div v-if="data.type === 'dashboardLinks'">
                        <Links :data="data" :options="options" :unique_id="unique_id"></Links>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {BubbleMenu, FloatingMenu,} from '@tiptap/vue-3'
import ContentBlock from "./Res/ContentBlock";
import TextBlock from "./Res/TextBlock";
import Links from "../../../resources/Res/Links";
import TextEditor from "../../../../../elements/TextEditor";

export default {
    props: ['data', 'options', 'unique_id'],
    components: {
        TextEditor,
        TextBlock,
        ContentBlock,
        Links,
        BubbleMenu,
        FloatingMenu,
    },
    created() {
        this.data.unique_id = this.unique_id;
    }
}
</script>

<style lang="scss">
.ProseMirror {
    min-height: 70px;

    > * + * {
        margin-top: 0.75em;
    }

    ul,
    ol {
        padding: 0 1rem;
    }

    blockquote {
        padding-left: 1rem;
        border-left: 2px solid rgba(#0D0D0D, 0.1);
    }

    &:focus, &:active {
        outline: none;
    }

    h1 {
        font-weight: bold;
        font-size: 32px;
        line-height: 1.1;
    }

    h2 {
        font-weight: bold;
        font-size: 24px;
        line-height: 1.1;
    }
}

.tiptap-menu {
    display: flex;

    button {
        border: none;
        background: none;
        color: #FFF;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.4rem;
        opacity: 0.6;

        &:focus, &:active {
            outline: none;
        }

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}

.floating-menu {
    display: flex;
    background-color: #111827;
    padding: 0.2rem;
    border-radius: 0.5rem;

    button {
        border: none;
        background: none;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.2rem;
        opacity: 0.6;

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}
</style>
